import {
    $, addAction, INIT, LAYOUT,
} from '@situation/setdesign.util';
import BackgroundVideo from '../shared/background-video';

addAction(INIT, () => {
    const $backgroundVideo = $('[data-video-bg]');
    let currentBreakpoint = -1;
    let instance = false;
    const settings = { resizing: false, posterType: 'jpg', autoplay: false };
    if (!$backgroundVideo.length) {
        return;
    }

    const videos = $backgroundVideo.data('videoBg').map((video) => new BackgroundVideo(video));
    const breakpoints = videos.map((video) => video.range[0]);
    const videoMatch = (width) => videos.filter((video) => video.matches(width)).pop();
    const breakpointMatch = (width) => breakpoints.filter((breakpoint) => width >= breakpoint).pop();

    const hasBreakpointChanged = () => {
        const breakpoint = breakpointMatch(SetDesign.viewport.width());
        const ret = breakpoint !== currentBreakpoint;
        currentBreakpoint = breakpoint;
        return ret;
    };

    /** @param {BackgroundVideo} video */
    const initializeVideo = (video) => {
        if (!video) {
            return;
        }
        if (instance) {
            instance.destroy();
            $backgroundVideo.parent().removeClass('background-video--playing');
        } else {
            $backgroundVideo.html('');
        }

        $backgroundVideo.css('padding-top', `${video.pad()}%`);
        $backgroundVideo.vide(video.paths(), settings);
        instance = $backgroundVideo.data('vide');
        const $video = $(instance.getVideoObject());
        $video.one('playing.vide', () => {
            $backgroundVideo.parent().addClass('background-video--playing');
        });

        $video[0].setAttribute('playsinline', '');
        $video.find('source').each((_i, el) => {
            let src = el.getAttribute('src');
            const extCount = (src.match(/\.mp4/g) || []).length;
            if (extCount > 1) {
                src = src.replace(/\.mp4+$/, '');
                el.setAttribute('src', src);
            }
        });

        $video[0].play();
    };

    addAction(LAYOUT, () => {
        if (hasBreakpointChanged()) {
            initializeVideo(videoMatch(currentBreakpoint));
        } else if (instance) {
            instance.resize();
        }
    });
});
